module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Grid",
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-163d4485"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid.vue
// module id = 742
// module chunks = 1474